import { COOKIE_KEY } from "@/constants/cookieKey";
import useAppStore from "@/context/store";
import { safeParse } from "@/utils/safeParse";
import Cookies from "js-cookie";

enum TYPE {
  "ORIGINAL", // 不处理
  "RM_GD", // 移除bucket前缀的gd-
  "ADD_GD", // 添加bucket前缀的gd-
  "USE_EDGE", // 使用edge
}

class ImageUrlConfig {
  imageConfig: {
    domain: string;
    bucket?: string;
    bucketHandMethod: TYPE;
  };
  init: boolean;
  /** 是否已经切换过域名 */
  hasSwitchFlag: boolean = false;
  constructor() {
    // 默认需要做一套兜底配置
    this.imageConfig = {
      domain: "huaban.com",
      bucketHandMethod: TYPE.USE_EDGE,
    };
    this.init = false;
  }

  /**
   *
   * @param originBucket 原始bucket 图片file对象里的bucket
   * @returns 当前图片域名配置信息
   */
  get(originBucket: string) {
    // 服务端时imageUrlConfig为单例，需要直接返回
    if (typeof window === "undefined") {
      const cookieImgConfig = safeParse(
        useAppStore.getState()?.initImageConfig,
        () => undefined
      );

      if (cookieImgConfig) {
        this.hasSwitchFlag = true;
      }

      /**
       * 取配置顺序
       * 1.cookie设置的
       * 2.杂货铺第一个
       * 3.代码兜底
       */
      const imageConfig =
        cookieImgConfig ||
        useAppStore.getState()?.config?.imageConfigList?.[0] ||
        this.imageConfig;

      imageConfig.bucket = this.getBucket(
        originBucket,
        imageConfig.bucketHandMethod
      );

      return imageConfig;
    } else {
      if (!this.init) {
        this.init = true;

        const cookieImgConfig = safeParse(
          Cookies.get(COOKIE_KEY.IMAGE_URL_CONFIG),
          () => undefined
        );

        if (cookieImgConfig) {
          this.hasSwitchFlag = true;
        }
        /**
         * 取配置顺序
         * 1.cookie设置的
         * 2.杂货铺第一个
         * 3.代码兜底
         */
        this.imageConfig =
          cookieImgConfig ||
          useAppStore.getState()?.config?.imageConfigList?.[0] ||
          this.imageConfig;
      }
      // bucket每次都需要处理下
      this.imageConfig.bucket = this.getBucket(
        originBucket,
        this.imageConfig.bucketHandMethod
      );
      return this.imageConfig;
    }
    // 客户端
  }
  getBucket = (originBucket: string, bucketHandMethod: TYPE) => {
    if (bucketHandMethod === TYPE.ORIGINAL) {
      return originBucket;
    }

    let newBucket = originBucket;

    // 默认 ADD_GD 逻辑：添加 gd- 前缀
    if (originBucket.indexOf("gd-") !== 0 && bucketHandMethod === TYPE.ADD_GD) {
      newBucket = "gd-" + originBucket;
    }

    if (bucketHandMethod === TYPE.RM_GD) {
      newBucket = originBucket.replace("gd-", "");
    }

    if (bucketHandMethod === TYPE.USE_EDGE) {
      newBucket = "gd-hbimg-edge";
    }

    return newBucket;
  };

  set(imageConfig: { domain: string; bucketHandMethod: TYPE }) {
    this.imageConfig = imageConfig;
    Cookies.set(COOKIE_KEY.IMAGE_URL_CONFIG, imageConfig);
  }
}
const imageUrlConfig = new ImageUrlConfig();

export { imageUrlConfig };
